<template>
    <main>
        <div class="header"></div>
        <div class="bg">
            <div class="login-box">
                <div class="left banner">
                    <div class="logo-box"></div>
                </div>
                <div class="left login">
                    <div class="tab">
                        <div class="item" :class="[tab == 2 ? 'active' : '']" @click="setTab(2)"
                            v-if="!smsLoginDisabled">验证码登录</div>
                        <div class="item" :class="[tab == 1 ? 'active' : '']" @click="setTab(1)"
                            v-if="disasterRecoveryEnabled">密码登录</div>
                    </div>
                    <div class="info">
                        <form action="" @keyup.enter="doLogin">
                            <div class="item" :class="[tab == 1 ? 'active' : '']" v-if="disasterRecoveryEnabled">
                                <div class="input" :class="[error.username ? 'error' : '']">
                                    <span class="left icon icon-user"></span>
                                    <input type="text" class="left in" @blur="validate('username')"
                                        placeholder="请输入邮箱账号/手机号" v-model="username">
                                </div>
                                <div class="validate">{{ error.username }}</div>
                                <div class="input" :class="[error.password ? 'error' : '']">
                                    <span class="left icon icon-password"></span>
                                    <input type="password" class="left in" @blur="validate('password')"
                                        placeholder="请输入密码" v-model="password">
                                </div>
                                <div class="validate">{{ error.password }}</div>
                            </div>
                            <div class="item " :class="[tab == 2 ? 'active' : '']" v-if="!smsLoginDisabled">
                                <div class="input" :class="[error.phone ? 'error' : '']">
                                    <span class="left icon icon-phone"></span>
                                    <input type="text" class="left in" @blur="validate('phone')" placeholder="请输入手机号码"
                                        v-model="phone">
                                </div>
                                <div class="validate">{{ error.phone }}</div>
                                <div class="input code" :class="[error.code ? 'error' : '']">
                                    <span class="left icon icon-message"></span>
                                    <input type="text" class="left in" @blur="validate('code')" placeholder="请输入验证码"
                                        v-model="code">
                                    <span class="left btn" :class="code_status ? '' : 'hidden'"
                                        @click="getCode">{{ code_text }}</span>
                                </div>
                                <div class="validate">{{ error.code }}</div>
                            </div>
                            <div class="submit" @click="doLogin">登录</div>
                            <div class="action">
                                <div class="right">
                                    <div class="left link" @click="toRegister" style="border-right: none;">立即报名</div>
                                    <!--                                    <div class="left link" @click="show_tab1 = true;tab= 1;" id="pwlogin" style="display: none">密码登录</div>-->
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <service></service>
    </main>
</template>

<script>
import Service from "../../components/pc/Service";
import util from "@/common/util";
export default {
    name: 'login',
    data() {
        return {
            query: "",
            tab: 2,
            show_tab1: false,
            username: "",
            password: "",
            phone: "",
            code: "",
            code_text: "获取验证码",
            code_status: true,
            error: {},
            logo: [require('@/assets/image/49.png'), require('@/assets/image/50.png')],
            // 灾备相关
            disasterRecoveryEnabled: false, // 是否启用灾备模式（密码登录）
            smsLoginDisabled: false, // 是否禁用短信登录
        }
    },
    components: {
        Service

    },
    computed: {

    },
    watch: {
        $route() {
            this.util.showBottom(true);
        }
    },
    methods: {
        // 检查灾备状态
        checkDisasterRecovery() {
            // 检查登录类型
            this.http.request({
                api: 'auth/loginType',
                async: 1,
                success: (res) => {
                    if (res && res.loginType === 1) {
                        // loginType为1时启用密码登录
                        this.disasterRecoveryEnabled = true;
                        // 启用灾备时直接禁用短信登录
                        this.smsLoginDisabled = true;
                        // 自动切换到密码登录
                        this.tab = 1;
                    } else {
                        // loginType为0或其他值时使用验证码登录
                        this.disasterRecoveryEnabled = false;
                        this.smsLoginDisabled = false;
                        this.tab = 2;
                    }
                },
                error: (res) => {
                    // 接口调用失败时，保持默认状态（验证码登录）
                    console.log('登录类型检查失败:', res);
                    this.disasterRecoveryEnabled = false;
                    this.smsLoginDisabled = false;
                    this.tab = 2;
                }
            });
        },

        toRegister() {
            this.$router.push({
                path: "/register",
                query: {
                    from: this.$route.query.from ? this.$route.query.from : (this.$route.path == '/login' || this.$route.path == '/register') ? '/' : this.$route.fullPath
                }
            })
        },

        validate(field) {
            var message = "";
            switch (field) {
                case 'username':
                    if (!this.username) {
                        message = "请输入邮箱账号/手机号";
                    } else if (!this.tool.type.checkStr(this.username, 'email') && (this.isCn() && !this.tool.type.checkStr(this.username, 'phone'))) {
                        message = "邮箱账号/手机号格式不正确";
                    } else {
                        message = "";
                    }
                    break;
                case 'password':
                    if (!this.password) {
                        message = "请输入密码";
                    } else {
                        message = "";
                    }
                    break;
                case 'phone':
                    if (!this.phone) {
                        message = "请输入手机号码";
                    } else {
                        const isEmail = this.tool.type.checkStr(this.phone, 'email');
                        const hasEmailPrefix = this.phone.includes('@');

                        if (hasEmailPrefix && !isEmail) {
                            message = "邮箱账号格式不正确";
                        } else if (!isEmail && (this.isCn() && !this.tool.type.checkStr(this.phone, 'phone'))) {
                            message = "手机号码格式不正确";
                        } else {
                            message = "";
                        }
                    }
                    break;
                case 'code':
                    if (!this.code) {
                        message = "请输入验证码";
                    } else {
                        message = "";
                    }
                    break;
                default:
                    break;

            }
            this.setError(field, message);
            return message ? false : true;
        },
        setError(name, message = "") {
            this.error[name] = message;
            this.$forceUpdate();
        },
        setTab(index) {
            this.tab = index;
        },
        doLogin() {
            var api, data;
            if (this.tab == 1) {
                var username = this.validate('username');
                var password = this.validate('password');
                if (!username || !password) {
                    return false;
                }

                api = 'auth/loginByPasswordForEn';
                if (this.isCn()) {
                    api = "auth/loginByPassword"
                }
                data = {
                    username: this.username,
                    password: this.password,
                    loginType: this.tool.type.checkStr(this.username, 'email') ? 'email' : 'mobile',
                }
            }
            if (this.tab == 2) {
                var phone = this.validate("phone");
                var code = this.validate('code');
                if (!phone || !code) {
                    return false;
                }

                api = 'auth/loginByCodeForEn';
                if (this.isCn()) {
                    api = "auth/loginByCode"
                }
                data = {
                    phone: this.phone,
                    code: this.code,
                    loginType: this.tool.type.checkStr(this.phone, 'email') ? 'email' : 'mobile'
                }
            }

            this.http.request({
                api: api,
                data: data,
                loading: true,
                success: (res) => {
                    if (res.access_token) {
                        this.util.setAccessToken(res.access_token);
                        this.getUserInfo(res.access_token);
                    } else {
                        this.$store.commit('setUserThumb', res.user);
                        this.util.toLink('/registration', this.$route.query);
                    }
                },
                error: (res) => {
                    this.$toast.fail({
                        message: res.msg,
                    });
                }
            })
        },
        getUserInfo(access_token = '') {
            this.http.request({
                api: 'user/getUserInfo',
                data: {
                    access_token: access_token
                },
                loading: true,
                success: (res) => {
                    // 登录用户变量
                    var gioParams = {
                        // area_ppl: (res.user.province + res.user.city) || "",//省份,城市
                        // companyName_ppl: res.user.company || "",//公司名称
                        // companyScale_ppl: "",//公司规模
                        // email_ppl: res.user.email || "",//邮箱
                        // industry_ppl: res.user.job || "",//行业
                        // phone_ppl: res.user.phone || "",//手机
                        // userName_ppl: res.user.username || "",//姓名
                        // userRole_ppl: "",//职位
                    };
                    gio('people.set', gioParams);
                    //登录用户ID
                    gio('setUserId', res.user.id);
                    //登录用户类型
                    gio('track', 'loginSuccess',
                        {
                            'user_Id': res.user.memberId,  // memberId
                            'phoneNumber': util.encryptPhone(res.user.phone),  //登录手机号
                            'loginType': this.tab == 2 ? '短信' : '密码' // 短信或账号 密码登录的为“账号” 短信验证码登录的为“短信”
                        })
                    // console.log(3,res.user);
                    this.$store.commit('setUserInfo', res.user);
                    this.util.setDellCookie();
                    this.toBack();
                }
            })
        },
        getCode() {
            if (!this.code_status) { return false; }
            var phone = this.validate("phone");
            if (!phone) {
                return false;
            }

            // 检查是否为邮箱格式
            const isEmail = this.tool.type.checkStr(this.phone, 'email');

            var api = "sms/loginForEn";
            if (this.isCn()) {
                api = "sms/login"
            }
            this.http.request({
                api: api,
                type: "POST",
                data: {
                    phone: this.phone,
                    type: isEmail ? 'email' : 'mobile'
                },
                loading: true,
                success: (res) => {
                    this.cutTime();
                },
                error: (res) => {
                    this.$toast.fail(res.msg); return false;
                }
            })
        },
        cutTime() {
            this.code_status = false;
            var number = 59;
            this.code_text = "重新获取(" + number + "s)";
            var timer = setInterval(() => {
                number = number - 1;
                if (number <= 0) {
                    clearInterval(timer);
                    this.code_text = "获取验证码"
                    this.code_status = true;
                } else {
                    this.code_text = "重新获取(" + number + "s)";
                }
            }, 1000)
        },
        toBack() {
            this.util.toBack();
        },
        isCn() {
            return true;
        },
        checkLogin() {
            if (!this.util.getAccessToken()) {
                return false;
            }
            this.http.request({
                api: 'user/getUserInfo',
                async: 1,
                success: (res) => {
                    // 登录用户变量
                    var gioParams = {
                        // area_ppl: (res.user.province + res.user.city) || "",//省份,城市
                        // companyName_ppl: res.user.company || "",//公司名称
                        // companyScale_ppl: "",//公司规模
                        // email_ppl: res.user.email || "",//邮箱
                        // industry_ppl: res.user.job || "",//行业
                        // phone_ppl: res.user.phone || "",//手机
                        // userName_ppl: res.user.username || "",//姓名
                        // userRole_ppl: "",//职位
                    };
                    gio('people.set', gioParams);
                    //登录用户ID
                    gio('setUserId', res.user.id);
                    //登录用户类型
                    gio('track', 'loginSuccess', {
                        'user_Id': res.user.memberId,  // memberId
                        'phoneNumber': util.encryptPhone(res.user.phone),  //登录手机号
                        'loginType': this.tab == 2 ? '短信' : '密码' // 短信或账号 密码登录的为“账号” 短信验证码登录的为“短信”
                    })
                    // console.log(2,res.user);
                    this.$store.commit('setUserInfo', res.user);
                    this.util.setDellCookie();
                    this.util.toBack();
                }
            })
        }
    },
    mounted() {
        this.query = this.$route.query;
        this.checkLogin();
        this.checkDisasterRecovery(); // 检查灾备状态
        this.util.showBottom(true);
        // if(this.tool.other.getUrlParams('show_password') == 1){
        //     $("#pwlogin").show();
        // }
    }
}
</script>

<style lang="scss" type="text/scss" scoped>
.header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 80px;
    text-align: center;
    color: #fff;
    border-bottom: 1px solid rgba(255, 255, 255, .2);
    z-index: 99;
    background: #9fddff;
}

.bg {
    height: 746px;
    background: #9fddff;
    position: relative;

    .login-box {
        width: 1200px;
        height: 400px;
        position: absolute;
        top: 170px;
        left: 50%;
        margin-left: -600px;
        z-index: 2;

        .banner {
            width: 740px;
            height: 400px;
            background: url("~@/assets/image/2026/login-kv.png") no-repeat center center;
            background-size: cover;
            color: #fff;
            position: relative;

            .middle {
                height: 400px;
                padding-left: 40px;

                .title {
                    width: 700px;
                    margin-top: -25px;

                    img {
                        max-width: 100%;
                        margin-left: -10px;
                    }
                }

                .m-title {
                    display: none;
                    margin-top: -80px;

                    .img {
                        width: 300px;
                        height: 30px;
                        margin-left: 18px;
                        background: url("~@/assets/image/83.png") no-repeat center center;
                        background-size: contain;
                        float: left;
                    }
                }

                .logo {
                    position: absolute;
                    bottom: 20px;
                    right: 20px;
                    width: 272px;
                    height: 33px;
                    background: url("~@/assets/image/logo.png") no-repeat center center;
                    background-size: contain;
                }
            }

            .logo-box {
                position: absolute;
                bottom: 15px;
                left: 25px;
                width: 190px;
                height: 64px;
                background: url("~@/assets/image/82.png") no-repeat center center;
                background-size: contain;
                display: none;
            }
        }

        .login {
            width: 460px;
            height: 400px;
            background: #fff;

            .tab {
                height: 70px;
                border-bottom: 2px solid #f1f1f1;
                box-sizing: border-box;

                .item {
                    float: left;
                    text-align: center;
                    width: 160px;
                    line-height: 70px;
                    font-size: 18px;
                    position: relative;
                    transition: all .3s ease;
                    cursor: pointer;
                }

                .item::after {
                    content: "";
                    display: block;
                    width: 50px;
                    height: 4px;
                    background: #000;
                    position: absolute;
                    bottom: 0;
                    left: 50%;
                    margin-left: -25px;
                    opacity: 0;
                    transition: all .3s ease;
                }

                .item.active {
                    font-weight: bold;
                    transition: all .3s ease;
                }

                .item.active::after {
                    opacity: 1;
                    transition: all .3s ease;
                }
            }

            .info {
                .item {
                    display: none;
                    padding-top: 30px;
                    padding-left: 45px;

                    .input {
                        width: 362px;
                        height: 40px;
                        border: 1px solid #ddd;
                        border-radius: 5px;
                        overflow: hidden;
                        position: relative;

                        .icon {
                            display: block;
                            float: left;
                            width: 40px;
                            height: 40px;
                        }

                        .icon.icon-user {
                            background: url("~@/assets/image/16.png") no-repeat center center;
                            background-size: 17px;
                        }

                        .icon.icon-phone {
                            background: url("~@/assets/image/14.png") no-repeat center center;
                            background-size: 17px;
                        }

                        .icon.icon-message {
                            background: url("~@/assets/image/15.png") no-repeat center center;
                            background-size: 18px;
                        }

                        .icon.icon-password {
                            background: url("~@/assets/image/password.png") no-repeat center center;
                            background-size: 19px;
                        }

                        .in {
                            width: 300px;
                            height: 40px;
                            border: none;
                            background: #fff;
                            font-size: 16px;
                            color: #000;
                        }

                        .in::placeholder {
                            color: #666;
                        }

                        .btn {
                            position: absolute;
                            top: 0;
                            right: 0;
                            width: 100px;
                            height: 40px;
                            line-height: 40px;
                            font-size: 14px;
                            border-left: 1px solid #ddd;
                            text-align: center;
                            cursor: pointer;
                            z-index: 2;
                        }
                    }

                    .validate {
                        height: 30px;
                        line-height: 30px;
                        font-size: 14px;
                        color: red;
                    }

                    .input.code {
                        .in {
                            width: 200px;
                        }
                    }

                    .input.error {
                        border-color: #ff0000;
                    }
                }

                .item.active {
                    display: block;
                }

                .submit {
                    width: 365px;
                    margin: 0 auto 0;
                    height: 45px;
                    line-height: 45px;
                    text-align: center;
                    color: #fff;
                    font-size: 18px;
                    background: #1D56C0;
                    border-radius: 5px;
                    box-shadow: 0 0 10px 5px rgba(1, 118, 206, .1);
                    cursor: pointer;
                    transition: all .3s ease;
                }

                .submit:hover {
                    color: #000;
                    transition: all .3s ease;
                }

                .action {
                    width: 365px;
                    margin: 20px auto 0;

                    .right {
                        .link {
                            height: 13px;
                            line-height: 13px;
                            font-size: 16px;
                            color: #565656;
                            padding: 0 10px;
                            border-right: 1px solid #565656;
                            cursor: pointer;
                            transition: all .3s ease;
                        }

                        .link:nth-last-child(1) {
                            border-right: 0;
                            padding-right: 0;
                        }

                        .link:hover {
                            color: #1D56C0;
                            transition: all .3s ease;
                        }
                    }
                }
            }
        }
    }
}
</style>
